import {
  Alert,
  Button,
  Checkbox,
  DatePicker,
  Form,
  Select,
  Space,
  Table,
  Upload,
  message,
} from 'antd';
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getMarcas } from '../actions/evaluacionOptima';
import { UploadOutlined } from '@ant-design/icons';
import {
  changeFilter,
  importExcel,
  setReportesAbiertos,
  resetIndicador,
} from '../actions/evaluacionGarantias';

function EvaluacionGarantias() {
  const { Option } = Select;
  const [searchReports, setSearchReports] = useState(false);

  const [form] = Form.useForm();
  const [unidad, setUnidad] = useState([]);
  const [file, setFile] = useState(null);
  const { marcas } = useSelector((state) => state.evaluacionOptima);
  const { fecha, error, save, message, reportesAbiertos } = useSelector(
    (state) => state.evaluacionGarantias
  );

  const columnas = [
    {
      title: 'tipo_orden',
      dataIndex: 'tipo_orden',
      key: 'tipo_orden',
    },
    {
      title: 'estatus_orden',
      dataIndex: 'estatus_orden',
      key: 'estatus_orden',
    },
    {
      title: 'mes',
      dataIndex: 'mes',
      key: 'mes',
    },
    {
      title: 'anio',
      dataIndex: 'anio',
      key: 'anio',
    },
    {
      title: 'fecha',
      dataIndex: 'fecha',
      key: 'fecha',
    },
    {
      title: 'orden',
      dataIndex: 'orden',
      key: 'orden',
    },
    {
      title: 'no_serie',
      dataIndex: 'no_serie',
      key: 'no_serie',
    },
    {
      title: 'estatus_ordenes',
      dataIndex: 'estatus_ordenes',
      key: 'estatus_ordenes',
    },
  ];
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getMarcas());

    // return setUnidad([]);
  }, []);

  useEffect(() => {
    if (error) {
      setTimeout(() => {
        dispatch(resetIndicador());
      }, [3000]);
    }
  }, [error]);
  useEffect(() => {
    if (save) {
      setTimeout(() => {
        dispatch(resetIndicador());
      }, [3000]);
    }
  }, [save]);

  const onChangeDate = (date, dateString) => {
    dispatch(changeFilter('fecha', date));
  };

  const checkForm = () => {
    setSearchReports(!searchReports);

    if (!searchReports) {
      dispatch(resetIndicador());
    }
  };

  const onFinish = (values) => {
    searchReports
      ? dispatch(setReportesAbiertos(values))
      : dispatch(importExcel(values));

    setFile([]);
    form.resetFields();
  };

  const onHandlerUnidad = (value) => {
    const marca = marcas.filter(({ id }) => id === value);
    setUnidad(marca[0].unidades);
  };

  const beforeUpload = (file) => {
    const isExcel =
      file.type === 'application/vnd.ms-excel' ||
      file.type ===
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
    if (!isExcel) {
      message.error('Solo se permiten archivos Excel (.xls, .xlsx)');
    } else {
      setFile(file);
    }
    return false;
  };

  return (
    <>
      <Checkbox onChange={checkForm}>Buscar Reportes abiertos</Checkbox>
      <Form form={form} onFinish={onFinish}>
        <Form.Item label="Marcas" name="marca">
          <Select onChange={onHandlerUnidad}>
            {marcas.map(({ id, nombre }) => (
              <Option value={id} key={id}>
                {nombre}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item label="Unidad de negocio" name="unidad">
          <Select>
            {unidad.map(({ id, nombre }) => (
              <Option value={id} key={id}>
                {nombre}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item label="Fecha" name="fecha">
          <DatePicker
            value={fecha}
            onChange={onChangeDate}
            placeholder="Periodo"
            style={{ width: 120 }}
            picker="month"
            size={'small'}
          />
        </Form.Item>
        {!searchReports && (
          <Form.Item name="file">
            <Upload
              beforeUpload={beforeUpload}
              accept=".xls,.xlsx"
              multiple={false}
              fileList={file ? [file] : []}
            >
              <Button icon={<UploadOutlined />}>
                Seleccionar archivo Excel
              </Button>
            </Upload>
          </Form.Item>
        )}
        <Form.Item>
          <Button type="primary" htmlType="submit">
            Enviar
          </Button>
        </Form.Item>
      </Form>
      {save ? (
        <Space direction="vertical" style={{ width: '100%' }}>
          <Alert message={message} type="success" />
        </Space>
      ) : null}
      {error && (
        <Space direction="vertical" style={{ width: '100%' }}>
          <Alert message={message} type="error" />
        </Space>
      )}

      {reportesAbiertos.length > 0 && (
        <Table dataSource={reportesAbiertos} columns={columnas} />
      )}
    </>
  );
}

export default EvaluacionGarantias;
